import { ServiceApi } from "./Api";
import { loadProgressBar } from 'axios-progress-bar';

export class MedicoService {

    PostAdicionarParecer(parecerDTO) {
        loadProgressBar();
        return ServiceApi.post("api/Portal/PostAdicionarParecer", parecerDTO);
    }

    GetParecerMedico(pedidoId){
        loadProgressBar();
        return ServiceApi.post("api/Portal/PostListarParecerMedico?pedidoId="+pedidoId);        
    }
      
}